import AuthenticatedRemoteService from '@avtechsoftware/ra-javascript-utilities/src/utilities/authentication/AuthenticatedRemoteService';
import { sessionHash } from './remoteServiceUtil';

class RaaAuthenticatedRemoteService {
}
let globalInstance = null;

RaaAuthenticatedRemoteService.globalInstance = () => {
  if (!globalInstance) {
    globalInstance = new AuthenticatedRemoteService();
    globalInstance.setNonBearerAuthToken(sessionHash);
  }
  return globalInstance;
};

/* istanbul ignore next */
RaaAuthenticatedRemoteService.clearGlobalInstance = () => {
  if (globalInstance) {
    globalInstance = null;
  }
};

export default RaaAuthenticatedRemoteService;
